import React from "react";
import "./InputField.css";

function InputField({ id, placeholder, value, onChange, disabled, hint, big, children }) {
  return (
    <div className="inputFieldWrapper">
      {children}
      {big ?  <textarea id={id} className="inputField big" disabled={disabled} type="tel" placeholder={disabled ? "" : placeholder} value={value} onChange={onChange} />:
      <input id={id} className="inputField" disabled={disabled} type="tel" placeholder={disabled ? "" : placeholder} value={value} onChange={onChange} />}
      <div className={disabled ? "disabledHint" : "hint"}>{hint}</div>
    </div>
  );
}

export default React.memo(InputField);
